import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AmbassadorService, AuthorizedAmbassador } from 'remarketing-angular-library';
import { ModalComponent } from 'remarketing-ui-components-lib';
import { take } from 'rxjs/operators';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'app-remove-authorized-ambassador-modal',
    templateUrl: './remove-authorized-ambassador-modal.component.html',
    styleUrls: ['./remove-authorized-ambassador-modal.component.scss'],
    imports: [TranslocoDirective, ModalComponent]
})
export class RemoveAuthorizedAmbassadorModalComponent {
  @Input() modalId: string;
  @ViewChild(ModalComponent) modal: ModalComponent;
  @Output() ambassadors = new EventEmitter();
  @Output() success = new EventEmitter<string>();
  @Output() error = new EventEmitter();

  public ambassador: AuthorizedAmbassador;

  constructor(
    private readonly ambassadorService: AmbassadorService
  ) {}

  show(ambassador: AuthorizedAmbassador) {
    this.ambassador = ambassador;
    this.modal.show();
  }

  removeAuthorizedAmbassador(uuid: string): void {
    this.ambassadorService.removeAuthorizedAmbassadors(uuid).pipe(take(1)).subscribe((response: any) =>
    {
      if (response && response.ambassadors) {
        this.ambassadors.emit(response.ambassadors);
        this.modal.close();
        this.success.emit(this.ambassador.name);
      }
    },
    () => {
      this.modal.close();
      this.error.emit();
    }
    );
  }

  reformatPhone(phone: string): string {
    if (phone) {
      phone = phone.replace(/-/g, '');
      if (phone.length > 0) {
        if (phone.length === 11) {
          phone = `(${phone.slice(1, 4)}) ${phone.slice(4, 7)}-${phone.slice(7)}`;
          return phone;
        } else {
          phone = `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
          return phone;
        }
      }
    }

    return undefined;
  }

  close() {
    this.modal.close();
  }
}
